import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./apply-access.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./apply-access.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApplyAccessConstants } from "./apply-access.constants";
import { map, take, takeUntil } from "rxjs/operators";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
import { Subject } from "rxjs";
import { ApiOrganisationConstants } from "../../../shared/constants/api-constants/api-organisation.constants";
import { AppControllerService } from "../../../app-controller.service";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { AlertType } from "../../../shared/models/alert";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let ApplyAccessComponent = class ApplyAccessComponent {
    http;
    appController;
    changeDetectorRefs;
    userInformationService;
    _destroy$ = new Subject();
    applyAccessHeader = ApplyAccessConstants.MAIN_HEADING_TEXT;
    selectOrganisationText = ApplyAccessConstants.SELECT_ORG_LABEL;
    chooseOptionText = ApplyAccessConstants.CHOOSE_OPTION_TEXT;
    applyBtnLabel = ApplyAccessConstants.APPLY_TEXT;
    organisationUrl = ApiOrganisationConstants.URL;
    applySuccessMessage = ApplyAccessConstants.APPLY_SUCCESS_TEXT;
    selectOrgText = ApplyAccessConstants.SELECT_ORG_TEXT;
    errorMessageObject = ApplyAccessConstants.ERROR_MESSAGE_OBJECT;
    userAlreadyApplied = ApplyAccessConstants.USER_APPLIED_MESSAGE;
    organisationSuspended = ApplyAccessConstants.ORGANISATION_SUSPENDED_TEXT;
    selectedOrganisationId;
    authenticatedUser;
    organisations = [];
    selectedOrganisationName;
    IOrganisationSubscription;
    authenticatedUserSubscription;
    constructor(http, appController, changeDetectorRefs, userInformationService) {
        this.http = http;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.userInformationService = userInformationService;
    }
    ngOnInit() {
        this.getOrganisations();
        this.getUserDetails();
    }
    getOrganisations() {
        this.IOrganisationSubscription = this.http.get(this.organisationUrl, {})
            .pipe(map(organisationValue => organisationValue.value))
            .subscribe(organisation => {
            this.onGetOrganisationsCompleted(organisation);
        }, error => {
            this.appController.handleServerErrorMessage(this.errorMessageObject, error, CRUDOperation.Get);
        });
    }
    onGetOrganisationsCompleted(response) {
        const organisations = response.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1)).
            filter(x => !this.authenticatedUser.organisations.find(y => y.id === x.id));
        this.organisations = [...organisations];
        if (this.organisations.length > 0) {
            this.chooseOptionText = ApplyAccessConstants.CHOOSE_OPTION_TEXT;
        }
        else {
            this.chooseOptionText = ApplyAccessConstants.OPTION_TEXT_NONE;
            this.appController.showMessage(this.userInformationService.isSysadminAdmin() ? ApplyAccessConstants.ADD_ORGANISATION_REQUIRED_SYSADMIN : ApplyAccessConstants.ADD_ORGANISATION_REQUIRED, AlertType.Info);
        }
        this.changeDetectorRefs.detectChanges();
    }
    getUserDetails() {
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.pipe(takeUntil(this._destroy$), take(1))
            .subscribe(authUser => {
            this.authenticatedUser = authUser;
        });
    }
    onOrganisationChange(organisation) {
        const org = organisation;
        const selectedOption = org.options[org.selectedIndex];
        this.selectedOrganisationId = +selectedOption.title;
        this.selectedOrganisationName = selectedOption.text;
    }
    onApplyToOrganisation($event) {
        if (this.selectedOrganisationId === undefined) {
            this.appController.showMessage(this.selectOrgText, AlertType.Warning);
            return;
        }
        const isOrgansationSuspended = this.organisations.find(organisation => organisation.id === this.selectedOrganisationId)?.suspended;
        if (isOrgansationSuspended) {
            this.appController.showMessage(this.organisationSuspended, AlertType.Warning);
            return;
        }
        const hasUserApplied = this.authenticatedUser.organisationApplications.
            some(organisationApplication => organisationApplication.id === this.selectedOrganisationId);
        if (hasUserApplied) {
            this.appController.showMessage(`${this.userAlreadyApplied} ${this.selectedOrganisationName}`, AlertType.Warning);
            return;
        }
        else {
            const request = this.applyToOrganisationRequest();
            request.subscribe((response) => {
                this.applyToOrganisationCompleted(response);
                this.authenticatedUser.organisationApplications.
                    push(this.organisations.find(organisation => organisation.id === this.selectedOrganisationId));
            }, error => {
                this.appController.handleServerErrorMessage(this.errorMessageObject, error, CRUDOperation.Add);
            });
        }
    }
    applyToOrganisationRequest() {
        return this.http.post(`${this.organisationUrl}/${this.selectedOrganisationId}/ApplyToOrganisation`, {
            userId: this.authenticatedUser.id
        });
    }
    applyToOrganisationCompleted(response) {
        this.appController.showMessage(this.applySuccessMessage, AlertType.Success);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: UserInformationService }
    ];
};
ApplyAccessComponent = __decorate([
    Component({
        selector: "app-apply-access",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ApplyAccessComponent);
export { ApplyAccessComponent };
